import { render, staticRenderFns } from "./AdminUserInvite.vue?vue&type=template&id=a7bb2046"
import script from "./AdminUserInvite.vue?vue&type=script&lang=js"
export * from "./AdminUserInvite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports